import { Component, computed, input, output, inject } from '@angular/core';

import { StepperService } from '../../services/stepper.service';
import { CropCyclePhase, CropCycleStep } from '../../shared/models/models';
import { StepCardComponent } from '../step-card/step-card.component';
import { TranslatePipe } from '@next/core-lib/i18n';

interface EnhancedStep extends CropCycleStep {
  absoluteStepNumber: number;
  isLastAbsoluteStep: boolean;
}

@Component({
    selector: 'app-phase-container',
    templateUrl: './phase-container.component.html',
    styleUrl: './phase-container.component.scss',
    imports: [StepCardComponent, TranslatePipe],
})
export class PhaseContainerComponent {
  private readonly stepperService = inject(StepperService);

  phase = input.required<CropCyclePhase>();
  phaseIndex = input.required<number>();
  phases = input.required<CropCyclePhase[]>();

  stepClick = output<number>();

  // Pre-calculate step numbers and flags for all steps in this phase
  enhancedSteps = computed<EnhancedStep[]>(() => {
    const phase = this.phase();
    const totalSteps = this.stepperService.getTotalSteps(this.phases());

    return phase.steps.map((step, stepIndex) => {
      const absoluteStepNumber = this.getAbsoluteStepNumber(stepIndex);
      return {
        ...step,
        absoluteStepNumber,
        isLastAbsoluteStep: absoluteStepNumber === totalSteps,
      };
    });
  });

  private getAbsoluteStepNumber(stepIndex: number): number {
    return this.stepperService.getAbsoluteStepNumber(this.phases(), this.phaseIndex(), stepIndex);
  }

  onStepClick(stepNumber: number): void {
    this.stepClick.emit(stepNumber);
  }
}
